var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c("div", { staticClass: "search__input-group" }, [
        _c(
          "label",
          { staticClass: "search__label", attrs: { for: _vm.id } },
          [
            !_vm.searchResultsOpen
              ? _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z",
                        stroke: "black",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M20.9999 20.9999L16.6499 16.6499",
                        stroke: "black",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    })
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "btn btn--close",
                    on: {
                      click: function($event) {
                        _vm.modelQuery = ""
                      }
                    }
                  },
                  [_c("span"), _c("span")]
                ),
            _vm._v(" "),
            _vm.loading ? _c("Loader") : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.modelQuery,
              expression: "modelQuery"
            }
          ],
          ref: "searchInput",
          staticClass: "search__input",
          attrs: { id: _vm.id, placeholder: _vm.placeholder },
          domProps: { value: _vm.modelQuery },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              _vm.results.length > 0 ? _vm.setActiveDescendant(0, $event) : null
            },
            focus: _vm.handleFocus,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.modelQuery = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.searchResultsOpen
        ? _c(
            "div",
            { staticClass: "search__results" },
            [
              _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                _vm.results.length
                  ? _c(
                      "ul",
                      {
                        staticClass: "search__results-list",
                        on: {
                          keyup: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "down", 40, $event.key, [
                                  "Down",
                                  "ArrowDown"
                                ])
                              ) {
                                return null
                              }
                              return _vm.setActiveDescendant(1, $event)
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "up", 38, $event.key, [
                                  "Up",
                                  "ArrowUp"
                                ])
                              ) {
                                return null
                              }
                              return _vm.setActiveDescendant(-1, $event)
                            }
                          ]
                        }
                      },
                      _vm._l(_vm.results, function(item, idx) {
                        return _c(
                          "li",
                          {
                            key: idx,
                            ref: "resultsListItem",
                            refInFor: true,
                            staticClass: "search__results-item",
                            attrs: {
                              id: "results-item-" + idx,
                              tabindex: "-1"
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectItem(item)
                              },
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.selectItem(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t"
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "search__message" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("errorSearchResultsEmpty")) +
                          "\n\t\t\t"
                      )
                    ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("custom")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }